import GifBoxOutlined from '@mui/icons-material/GifBoxOutlined'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import GiphySearchDialog from '@tenant/recognition/RecognitionModal/sendRecognitionView/giphySearch/GiphySearchDialog'
import useGiphyDialog from '@tenant/recognition/RecognitionModal/sendRecognitionView/giphySearch/useGiphyDialog'
import { T, useT } from '@transifex/react'
import { Control, FieldValues, Path, useController } from 'react-hook-form'

type GiphyPluginProps<T extends FieldValues> = {
  name: Path<T>
  control: Control<T>
  id: string
}

const GiphyPluginField = <T extends FieldValues>({ control, name, id }: GiphyPluginProps<T>) => {
  const t = useT()
  const { openGiphyDialog } = useGiphyDialog(id)

  const {
    field: { onChange },
  } = useController({ control, name })

  const handleAddGifClick = () => {
    !!openGiphyDialog && openGiphyDialog()
  }

  const handleGifSelected = (url: string) => {
    onChange?.(url)
  }

  return (
    <>
      <Tooltip id="tooltipAddGif" title={<T _str="Add GIF" />} placement="top">
        <Button
          id="btnAddGif"
          aria-labelledby="tooltipAddGif"
          onClick={handleAddGifClick}
          aria-label={t('Add gif')}>
          <GifBoxOutlined viewBox="4 4 16 16" />
        </Button>
      </Tooltip>
      <GiphySearchDialog onGifSelected={handleGifSelected} id={id} />
    </>
  )
}

export default GiphyPluginField
